import { watch } from 'vue';
import { useTheme as useVuetifyTheme } from 'vuetify';

import { useColorScheme } from './useColorScheme';

/** Mirrors the app's color scheme onto Vuetify's active theme (v4 API: theme.change). */
export function useVuetifyThemeSync(): void {
  const vuetify = useVuetifyTheme();
  const { scheme } = useColorScheme();
  watch(scheme, (next) => void vuetify.change(next), { immediate: true });
}
